import { render, staticRenderFns } from "./jhi-sort-indicator.vue?vue&type=template&id=7474229c&"
import script from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/iyabre/dev/perso/zeinabackend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7474229c')) {
      api.createRecord('7474229c', component.options)
    } else {
      api.reload('7474229c', component.options)
    }
    module.hot.accept("./jhi-sort-indicator.vue?vue&type=template&id=7474229c&", function () {
      api.rerender('7474229c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/sort/jhi-sort-indicator.vue"
export default component.exports